import styled, { keyframes, css } from 'styled-components'
import { easings } from 'constants/easings'

const reveal = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-5px)
  }
  100% {
    opacity: 1;
    transform: translateY(0)
  }
`

export const popoverStyles = css<PopoverContentProps>`
  ${({
    contentPadding = '8px',
    fillContent,
    fillWidth = '100%',
    theme: { colors, radii, shadows, transitions, zIndex },
  }) => css`
    display: flex;
    flex-direction: column;

    min-width: 100px;
    padding: ${contentPadding};
    z-index: ${zIndex[4]};

    border: 1px solid ${colors.border[1]};
    border-radius: ${radii.xxlarge};

    background: ${colors.background.secondary[1]};
    box-shadow: ${shadows.boxShadow.outer};
    background-clip: padding-box;
    ${fillContent && `width: calc(${fillWidth} + 2px);`};

    animation: ${reveal} ${transitions.duration[2]}
      ${easings.easeOutExponential};
  `}
`

const PopoverContent = styled.div`
  ${popoverStyles};
`

export interface PopoverContentProps {
  fillContent?: boolean
  fillWidth?: string
  contentPadding?: string
}

export default PopoverContent
